import { useTranslation } from "react-i18next";
import { Button } from "@foris/avocado-suite";
import RejectProposalModal from "@components/reject-proposal-modal";
import { canRejectProposal } from "@utils/assignmentProposal";
import { useActiveProposal } from "../../hooks/useActiveProposal";
import { useRejectActiveProposal } from "../../hooks/useRejectActiveProposal";

/**
 * The reject action of the editor, in the form and in the validation view, for a review the user
 * may reject.
 */
const ProposalRejectButton = () => {
  const { t } = useTranslation();
  const activeProposal = useActiveProposal();
  const { isOpen, open, close, reject, isSubmitting, errorMessage } = useRejectActiveProposal();

  if (!canRejectProposal(activeProposal)) return null;

  return (
    <>
      <Button variant="danger" onClick={open}>
        {t("assignation-edit.proposal.actions.reject")}
      </Button>

      {isOpen && (
        <RejectProposalModal
          requesterName={activeProposal?.requesterName}
          isSubmitting={isSubmitting}
          errorMessage={errorMessage}
          onCancel={close}
          onConfirm={reject}
        />
      )}
    </>
  );
};

export default ProposalRejectButton;
